import { render, staticRenderFns } from "./rubric_ai_upload.vue?vue&type=template&id=a043d630&scoped=true&"
import script from "./rubric_ai_upload.vue?vue&type=script&lang=js&"
export * from "./rubric_ai_upload.vue?vue&type=script&lang=js&"
import style0 from "./rubric_ai_upload.vue?vue&type=style&index=0&id=a043d630&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a043d630",
  null
  
)

export default component.exports